import React from "react";
import { Link } from "react-router-dom";

export default function LegalNotice({
  variant = "default", // "default" | "compact" | "footer"
  align = "left",
}) {
  const baseStyle = {
    fontSize: variant === "compact" ? "11px" : "12px",
    lineHeight: 1.5,
    color: "#94a3b8",
    marginTop: variant === "footer" ? "14px" : "10px",
    textAlign: align,
  };

  const linkStyle = {
    color: "#0f172a",
    fontWeight: 700,
    textDecoration: "underline",
  };

  return (
    <p style={baseStyle}>
      Education-only. Gildarc provides general educational information and does
      not offer tax advice, tax preparation, or filing services. Results may be
      incomplete and must be verified using official IRS instructions. See{" "}
      <Link to="/terms" style={linkStyle}>
        Terms of Use
      </Link>{" "}
      and{" "}
      <Link to="/privacy" style={linkStyle}>
        Privacy Policy
      </Link>
      .
    </p>
  );
}
